import { AnonymousWidgetPos } from "../types";

export function isHit(a: AnonymousWidgetPos, b: AnonymousWidgetPos) {
  "worklet";
  return (
    a.c === b.c &&
    a.x < b.x + b.w &&
    a.x + a.w > b.x &&
    a.y < b.y + b.h &&
    a.y + a.h > b.y
  );
}
